export default __webpack_public_path__ + "static/media/home-banner-02.7a17fe6c.svg";